<div class="remark-dialog-container">
  <h2 mat-dialog-title>
    <mat-icon class="dialog-title-icon">forum</mat-icon>
    Internal Remarks
    <button mat-icon-button class="close-btn" type="button" (click)="cancel()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <!-- Fixed section: never scrolls regardless of remark count -->
  <div class="dialog-fixed-header">
    @if (!data.detailId) {
      <div class="unsaved-warning">
        <mat-icon>info_outline</mat-icon>
        Remarks will be posted automatically when you save the record.
      </div>
    }
    @if (!loading) {
      <div class="remarks-table-header fx-align-space-between-center fx-row-wrap">
        <span class="fw-medium text-dark fs-6">Internal Remarks</span>
        @if (!data.isFormDisabled) {
          <button mat-button type="button" (click)="addRemark()">
            <mat-icon class="text-primary">add_circle</mat-icon>
            <span class="fw-medium ms-1">Add Internal Remark</span>
          </button>
        }
      </div>
    }
  </div>

  <mat-dialog-content>

    <!-- Loading -->
    @if (loading) {
      <div class="loading-row">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Loading remarks...</span>
      </div>
    }

    <!-- Table -->
    @if (!loading) {
      <div [formGroup]="form">
        <div class="table-window">
          <ng-container formArrayName="remarkDetails">
            <mat-table [dataSource]="remarksDataSource">
              <!-- Remarks column -->
              <ng-container matColumnDef="remarksText">
                <mat-header-cell *matHeaderCellDef>
                  <div class="table-heading ms-3">Remarks</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                  <!-- View (saved) -->
                  @if (!element.get('toSend').value) {
                    <div class="min-ht-50 w-100">
                      <div class="mt-2 ms-2 me-3 chat-bubble">
                        <div class="desc-box" [ngClass]="{'desc-active': element.get('expand').value}">
                          <pre class="text-dark fw-normal preserve-white-space">{{ element.get('remarksText').value }}</pre>
                        </div>
                      </div>
                      <div class="text-end me-3">
                        <button mat-icon-button (click)="toggleExpand(element)" color="primary" type="button">
                          <mat-icon>{{ !element.get('expand').value ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                  <!-- Input (new) -->
                  @if (element.get('toSend').value) {
                    <div class="remark-input-wrap">
                      <mat-form-field class="remark-form-field">
                        <textarea matInput formControlName="remarksText" cols="30" rows="4"
                        placeholder="  Write Remark.."></textarea>
                        @if (element.get('remarksText').errors?.required) {
                          <mat-error>Remark is required.</mat-error>
                        }
                        @if (element.get('remarksText').errors?.maxlength) {
                          <mat-error>Max 2000 characters.</mat-error>
                        }
                      </mat-form-field>
                    </div>
                  }
                </mat-cell>
              </ng-container>
              <!-- Date column -->
              <ng-container matColumnDef="remarksDate">
                <mat-header-cell *matHeaderCellDef>
                  <div class="table-heading ms-3">Date &amp; Time</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [formGroup]="element">
                  <div class="md-chips h-100 ms-3">
                    <div class="md-chip md-chip-hover fw-medium text-dark">
                      {{ element.get('remarksDate').value | date:'dd/MM/yyyy HH:mm' }}
                    </div>
                  </div>
                  <input hidden matInput formControlName="remarksDate" readonly tabindex="-1">
                </mat-cell>
              </ng-container>
              <!-- Remark by column -->
              <ng-container matColumnDef="remarkByUserName">
                <mat-header-cell *matHeaderCellDef>
                  <div class="table-heading ms-3">Remark by</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [formGroup]="element">
                  <div class="md-chips h-100 ms-3">
                    <div class="md-chip md-chip-hover fw-medium text-dark">
                      {{ element.get('remarkByUserName').value || loggedInUser?.name }}
                    </div>
                  </div>
                  <input hidden matInput formControlName="remarkByUserName" readonly tabindex="-1">
                </mat-cell>
              </ng-container>
              <!-- Action column -->
              <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef>
                  <div class="table-heading ms-3">Action</div>
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                  @if (element.get('toSend').value && !data.isFormDisabled) {
                    <div>
                      <span (click)="removeRemark(i)" class="cursorPointer ms-3">
                        <mat-icon class="text-danger">delete</mat-icon>
                      </span>
                    </div>
                  }
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
          </ng-container>
        </div>
        <!-- Empty state -->
        @if (remarkDetails.length === 0) {
          <div class="no-remarks">
            <mat-icon>chat_bubble_outline</mat-icon>
            <span>No remarks yet.</span>
          </div>
        }
      </div>
    }

    <!-- Actions sticky to bottom of scroll container — always visible -->
    <div class="csr-dialog-footer">
      <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
      @if (!data.isFormDisabled) {
        <button mat-raised-button color="primary" type="button" (click)="save()"
          [disabled]="saving">
          @if (saving) {
            <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
          }
          @if (!saving) {
            <mat-icon>save</mat-icon>
          }
          {{ saving ? 'Saving...' : 'Save' }}
        </button>
      }
    </div>

  </mat-dialog-content>
</div>
